var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    breakpoints = _ref.breakpoints,
    typography = _ref.typography,
    colors = _ref.colors;
  return {
    tabletBreakPoint: "max-width: ".concat(breakpoints.large),
    cardWrapperPadding: spacing.medium,
    viewPaddingRight: spacing.xxSmall,
    metricNumberContextFontSize: typography.fontSizeMedium,
    metricNumberContextFontWeight: typography.fontWeightNormal,
    blankBorderColor: colors.tiara,
    blankBorderRadius: '14px',
    blankMinWidth: '20px',
    blankHeight: '20px'
  };
};
export default generateComponentTheme;